import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@theStellarBlueprint/Store/CustomApplicationState";
import { getCuttingToolConfigState } from "@theStellarBlueprint/Store/Data/CuttingToolConfig/CuttingToolConfigSelector";
import removeCuttingToolConfigSelection from "@theStellarBlueprint/Store/Data/CuttingToolConfig/Handlers/RemoveAllConfig";
import updateCuttingToolConfigSelection from "@theStellarBlueprint/Store/Data/CuttingToolConfig/Handlers/UpdateCuttingToolConfigHanlder";
import CuttingToolPaginationHandler from "@theStellarBlueprint/Store/Data/CuttingToolPagination/Handlers/CuttingToolPagination";
import loadProducts from "@theStellarBlueprint/Store/Data/Products/Handlers/LoadProducts";
import produce from "immer";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    categoryId?: string;
    attributeValueIds: string[];
    getCurrentPage: {
        cuttingToolPageNumber: number,
        cuttingToolPageSize: number
    }
}

const mapStateToProps = (state: CustomApplicationState, Props: OwnProps) => {

    const productsByCategory = getProductsDataView(state, {
        categoryId: Props.categoryId,
        applyPersonalization: true,
        expand: ["attributes", "facets"],
        includeAttributes: ["includeOnProduct"],
        includeSuggestions: true,
        sort: "1",
        page: Props.getCurrentPage.cuttingToolPageNumber,
        pageSize: Props.getCurrentPage.cuttingToolPageSize,
        attributeValueIds: Props.attributeValueIds,
    });
    const attributes = getCuttingToolConfigState(state);

    return {
        products: productsByCategory,
        attributes,
    };
};

const mapDispatchToProps = {
    updateCuttingToolConfigSelection,
    removeCuttingToolConfigSelection,
    loadProducts,
    CuttingToolPaginationHandler,

};

export interface AttributesDropdownStyles {
    attributesContainer?: InjectableCss;
    attributesDropdowns?: InjectableCss;
    attributeSelector?: SelectPresentationProps;
    attributeValue?: InjectableCss;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    searchNotFound?: TypographyPresentationProps;
    searchNotFoundItem?: GridItemProps;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export const attributeStyles: AttributesDropdownStyles = {
    attributesContainer: {
        css: css`
            margin-top: 28px;
        `,
    },
    attributesDropdowns: {
        css: css`
            border: 1px solid #ccc;
            padding: 10px;
            margin-bottom: 10px;
        `,
    },
    gridContainer: {
        gap: 28,
        css: css`
            margin: 10px 0px 30px 0px;
        `,
    },
    gridItem: {
        width: [12, 12, 6, 4, 4],
    },
    searchNotFoundItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
        isplay: flex;
        justify-content: center;
        `
    },
    searchNotFound: {
        size: 20,
        css: css`
            text-align: center;
        `,
    },
};

const styles = attributeStyles;

const AttributesType: React.FC<Props> = ({
    products,
    updateCuttingToolConfigSelection,
    attributes,
    removeCuttingToolConfigSelection,
    loadProducts,
    categoryId,
    getCurrentPage,
    CuttingToolPaginationHandler,
}) => {
    const [attrArr, setAttrArr] = useState<string[]>([]);
    const attributeFacets = products.value && products["attributeTypeFacets"];
    const attributeFacetsUpdatedFlag = useRef(true);
    const [disableFilter, setDisableFilter] = useState(true);
    const [selectedAttrVal,setAttrVal]=useState<{ [key: string]: string }[]>([]);

    useEffect(() => {
        if (attributeFacets && attributeFacetsUpdatedFlag.current) {
            attributeFacetsUpdatedFlag.current = false;
            setAttrVal([]);
        }
      
    }, [attributeFacets]);

    useEffect(() => {
        setAttrVal([]);
    }, [categoryId]);
  
    useEffect(() => {
        if (attributeFacets && selectedAttrVal.length > 0) {
            const duplicateArr = [...selectedAttrVal];
            const attributeValueIds:string[]=[];
            let tempLen=0;
            duplicateArr.forEach(function(item) {
                Object.keys(item).forEach(function(key) {
                 if(item[key]==="")
                 {
                    tempLen=tempLen+1;
                 }
                 attributeValueIds.push(item[key]);
                });
              });
            updateCuttingToolConfigSelection({
                attributeValueIds,
            });
            if (tempLen === duplicateArr.length) {
                setDisableFilter(false)
            }else{
                setDisableFilter(true)
            }
        }
    }, [selectedAttrVal]);

    useEffect(() => {
        if (attributeFacetsUpdatedFlag.current) {
            attributeFacetsUpdatedFlag.current = false
        } else {
            loadProducts({
                categoryId,
                applyPersonalization: true,
                expand: ["attributes", "facets"],
                includeAttributes: ["includeOnProduct"],
                includeSuggestions: true,
                sort: "1",
                pageSize: getCurrentPage.cuttingToolPageSize,
                page: getCurrentPage.cuttingToolPageNumber,
                attributeValueIds: attributes.attributeValueIds,
            });
   
        }


    }, [attributes]);

    const handleAttributeValueId = (event: React.ChangeEvent<HTMLSelectElement>, attributeTypeId: string) => {
        event.persist();
        CuttingToolPaginationHandler({
            cuttingToolPageNumber: 1,
        })
        let temp = [...selectedAttrVal];
        const filArr=temp.filter(function (e) {
            // eslint-disable-next-line no-console
            return e[attributeTypeId];
        });

        if(filArr.length>0)
        {
            const newtemp = temp.map(el => (
                el[attributeTypeId]? {...el, [attributeTypeId]: event.target.value}: el
          ));
          temp=newtemp;
        }
        else{
            temp.push({ [attributeTypeId]: event.target.value });
        }
        
        setAttrVal(temp);

    };
  
    const removeAllFilters = () => {
        if (attributeFacets) {
            setAttrVal([]);
        }
        attributeFacetsUpdatedFlag.current = true
        removeCuttingToolConfigSelection({
            attributeValueIds: [],
        });
        setDisableFilter(false);
    };
    return (
        <StyledWrapper {...styles.attributesContainer} data-test-selector="attributesContainer">
            {attributes.attributeValueIds.length && disableFilter && products.value ? (
                <StyledWrapper>
                    <Link onClick={() => removeAllFilters()}>Remove All Filters</Link>
                </StyledWrapper>
            ) : null}
            {products.value ? (
                <StyledWrapper {...styles.attributesDropdowns} data-test-selector="attributesDropdowns">
                    <GridContainer {...styles.gridContainer}>
                        {products.value && products["attributeTypeFacets"] ?
                            products["attributeTypeFacets"]?.map((value, index) => {
                                return (
                                    <GridItem {...styles.gridItem} key={value.attributeTypeId}>
                                        <Select
                                            placeholder="Filter..."
                                            label={value.nameDisplay}
                                            value={selectedAttrVal && selectedAttrVal.length>0?selectedAttrVal.filter(function (e) {
                                                // eslint-disable-next-line no-console
                                                return e[value.attributeTypeId];
                                            })[0]?.[value.attributeTypeId]:""}
                                            onChange={e => handleAttributeValueId(e, value.attributeTypeId)}
                                        >
                                            <option value="">Select Option</option>
                                            {value.attributeValueFacets?.map(a => (
                                                <option key={a.attributeValueId} value={a.attributeValueId}>
                                                    {a.value}
                                                </option>
                                            ))}
                                        </Select>
                                    </GridItem>)

                            }) : <GridItem {...styles.searchNotFoundItem}><Typography variant="p" {...styles.searchNotFound}>{translate("We're sorry, your search returned no results.")}</Typography></GridItem>}
                    </GridContainer>
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AttributesType);
